import { TYPES } from '../flattenTree/utils/consts';

const throwOnIllegalTypes = (type, effect) => {
  if (!TYPES[type]) {
    throw new Error(
      `There is no type matching => ${type}. while trying to apply the following effect ${effect}`,
    );
  }
  return true;
};

export const applyToMembers = (category, fn, predicate) => {
  category.members.forEach((member) => {
    throwOnIllegalTypes(member.type) && predicate(member) && fn(member);
  });
};
